import React from 'react';
import { MENTION_STATUS } from '../../../../../types/dashboard.types';
import useDashboardMentions from '../../../../../hooks/useDashboardMentions';
import { MentionsColumn } from './MentionsColumn/MentionsColumn';

import './Tab1Mentions.scss';

/**
 * Componente que representa el primer tab del dashboard, correspondiente a la sección de menciones del chat de operaciones
 */
const Tab1Mentions = () => {
  const { filteredMentions, isColumnsLoading, obtainMentions } = useDashboardMentions({
    isCustomerChat: false
  });

  return (
    <div className="tab1Mentions">
      <h2 className="mentionsTitle">Te han mencionado</h2>

      <div className="mentionsColumnsContainer">
        <MentionsColumn
          status={MENTION_STATUS.PENDING_VIEWING}
          groupedMentions={filteredMentions.pendingViewingMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />

        <MentionsColumn
          status={MENTION_STATUS.PENDING_RESOLUTION}
          groupedMentions={filteredMentions.pendingResolutionMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />

        <MentionsColumn
          status={MENTION_STATUS.CLOSED}
          groupedMentions={filteredMentions.resolvedMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
        />
      </div>
    </div>
  );
};

export default Tab1Mentions;
